const usePermissionConfig = () => {
  return {
    /*
    * 创建用户
    * 控制：创建用户
    * 跳转路由名称：
    * */
    CREATE: 'OPS-AGL-KFZYHGL-CJYH',
    /*
    * 编辑
    * 控制：编辑
    * 跳转路由名称：
    * */
    UPDATE: 'OPS-AGL-KFZYHGL-BJ',
    /*
    * 启用停用
    * 控制：启用停用
    * 跳转路由名称：
    * */
    ENABLE: 'OPS-AGL-KFZYHGL-QYTY',
    /*
    * 操作记录
    * 控制：操作记录
    * 跳转路由名称：
    * */
    LOG: 'OPS-AGL-KFZYHGL-CZJL',
    /*
    * 删除
    * 控制：删除
    * 跳转路由名称：
    * */
    DELETE: 'OPS-AGL-KFZYHGL-SC',
    /*
    * 刷新在职状态数据
    * 控制：刷新在职状态数据
    * 跳转路由名称：
    * */
    REFRESH_WORK_STATUS: 'OPS-AGL-KFZYHGL-SXZZZT',
  };
};

export default usePermissionConfig;
